module.exports = __webpack_public_path__ + "static/media/main-bg2.44568a8b.jpg";